import { fetchRequest } from "@providers/conect";

const verCitasExtrasApi = async ( data ) => {
  try {
    const url = `administracion/citasextras`
    const response = await fetchRequest(url, {
      method: "POST",
      body:{
        ...data 
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const actualizarCitasExtrasApi = async ( id, cantidad ) => {
  try {
    const url = `administracion/citasextras/${id}`
    const response = await fetchRequest(url, {
      method: "PUT",
      body:{
        cantidad: cantidad
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

  const crearCitaExtraApi = async ( data ) => {
    try {
      const url = `administracion/citasextras/create`
      const response = await fetchRequest(url, {
        method: "POST",
        body: {
          oid_especialidad: data.oid_especialidad,
          oid_medico: data.oid_medico,
          cantidad: data.cantidad,
          idEsp: data.idEsp,
          oid_sede: data.oid_sede
        }
      });
      return response;
    } catch (error) {
      throw error;
    }
  };

  const bulkCreateCitasExtrasApi = async ( dataList ) => {
    try {
      const url = `administracion/citasextras/bulk-create`
      const response = await fetchRequest(url, {
        method: "POST",
        body: dataList
      });
      return response;
    } catch (error) {
      throw error;
    }
  };

export { verCitasExtrasApi, actualizarCitasExtrasApi, crearCitaExtraApi, bulkCreateCitasExtrasApi };